<template>
  <div class="add-staff-page">
    <div class="add-staff-page__header md-layout">
      <div class="md-layout-item">
        <div class="nav-link" @click="goToPreviousPage">
          <i class="fas fa-chevron-left"></i>
          <span>{{ $t("staff.add_new_staff") }}</span>
        </div>
      </div>
    </div>
    <staff-infos-form
      ref="infosForm"
      @onSubmit="addStaff"
      :serverValidations="serverValidations"
    ></staff-infos-form>
  </div>
</template>

<script>
import StaffInfosForm from "./StaffInfosForm";
import { service_paths } from "@/constants/Services";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { hasHistory, genErrMsgOj, Message } from "@/helpers/utils";
import { staff_router_names } from "@/routes/routes";

export default {
  components: { StaffInfosForm },
  name: "AddStaffPage",
  data() {
    return {
      serverValidations: {}
    };
  },
  mounted() {},
  methods: {
    addStaff(staffInfo) {
      const errMsg = this.$t("common.form_invalid");
      staffInfo.assigned_student_uuids = staffInfo.list_student_assign;
      let staffData = cloneDeep(staffInfo);
      staffData = omit(staffData, "list_student_assign");
      this.$axios
        .post(service_paths.staffs, staffData, true, {}, errMsg)
        .then(() => {
          Message.success(this.$t("common.add_success"));
          setTimeout(() => {
            this.$router.push({ name: staff_router_names.listPage });
          }, 500);
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
            console.log("this.serverValidations: ", this.serverValidations);
          }
        });
    },

    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.add-staff-page {
  &__header {
    margin-bottom: 30px;

    .nav-link {
      font-size: 1.5rem;
      color: #1b1f22;
      font-weight: 500;

      cursor: pointer;

      &:hover {
        color: lighten(#1b1f22, 20%);
      }

      span {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}

.add-staff-page {
  // padding-left: 30px;
  // padding-right: 30px;
}
</style>
